import React from 'react';
import { Logo } from './icons/Logo';

export const Footer = () => {
  return (
    <footer className="bg-brand-surface border-t border-brand-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <Logo size="small" />
              <span className="text-xl font-bold text-brand-text-primary">TestSeries</span>
            </div>
            <p className="text-brand-text-secondary text-sm mb-4">
              Professional exam practice portal designed to help students excel in competitive exams like JEE, NEET, NDA, and more.
            </p>
            <p className="text-xs text-brand-text-secondary">
              © {new Date().getFullYear()} TestSeries. All rights reserved.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-brand-text-primary mb-4">Platform</h3>
            <ul className="space-y-2 text-sm text-brand-text-secondary">
              <li><a href="/dashboard" className="hover:text-brand-primary cursor-pointer">Dashboard</a></li>
              <li><a href="/knowledge-sprint" className="hover:text-brand-primary cursor-pointer">Knowledge Sprint</a></li>
              <li><a href="/test-history" className="hover:text-brand-primary cursor-pointer">Test History</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-brand-text-primary mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-brand-text-secondary">
              <li><a href="/privacy-policy" className="hover:text-brand-primary cursor-pointer">Privacy Policy</a></li>
              <li><a href="/terms-of-service" className="hover:text-brand-primary cursor-pointer">Terms of Service</a></li>
              <li>
                <button 
                  onClick={() => {
                    localStorage.removeItem('cookieConsent');
                    window.location.reload();
                  }}
                  className="hover:text-brand-primary cursor-pointer text-left"
                >
                  Cookie Settings
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-brand-border">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-xs text-brand-text-secondary">
              Contact: <a href="mailto:nitishkumarsingh1@gmail.com" className="text-brand-primary hover:underline">nitishkumarsingh1@gmail.com</a>
            </p>
            <p className="text-xs text-brand-text-secondary mt-2 sm:mt-0">
              Made with ❤️ for students worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

